import { onMounted, onUnmounted } from 'vue'

import { hasOpenModal } from '../utils'

const spaceCode = 'Space' as const

export function useSpaceEventHandler(action: () => void): void {
  function isValidKeyEvent(event: KeyboardEvent): boolean {
    return event.code === spaceCode
  }

  function handleKeyEvent(e: KeyboardEvent): void {
    const focusedElement = document.activeElement

    if (
      isValidKeyEvent(e) &&
      focusedElement?.tagName !== 'INPUT' &&
      focusedElement?.tagName !== 'TEXTAREA' &&
      !hasOpenModal()
    ) {
      e.preventDefault()
      action()
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyEvent)
  })

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeyEvent)
  })
}
